import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Entry = (props: IconProps) => (
  <Icon width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14 9.88142L7.51493 0.296878L14 9.88142ZM14 9.88142H13.9979L14.1034 10.0374C14.3062 10.3371 14.0913 10.7389 13.7317 10.7389H10.7326C10.3735 10.7389 10.0831 11.0293 10.0831 11.3883V19.4506C10.0831 19.6992 9.8823 19.9 9.63374 19.9H4.64815C4.39959 19.9 4.19874 19.6992 4.19874 19.4506V11.3883C4.19874 11.0293 3.90835 10.7389 3.54934 10.7389H0.550224C0.190552 10.7389 -0.0240523 10.335 0.178292 10.0377L0.178432 10.0375L6.77127 0.296879L14 9.88142ZM6.77131 0.296821C6.94925 0.0343972 7.33693 0.0343932 7.51488 0.296809L6.77131 0.296821Z"
      fill="white"
      stroke="black"
      strokeWidth="0.2"
    />
  </Icon>
);
